import { Routes, Route } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SermonSupportPage from './SermonSupportPage';
import PraiseList from './worship/praise/PraiseList';
import PraiseDetail from './worship/praise/PraiseDetail';
import ContiMaker from './worship/conti/ContiMaker';

export default function MainAiserviceRouter() {
  return (
    <div>
      <Header/>

      <Routes>
        <Route path="/" element={<SermonSupportPage/>}/>
        <Route path="/support" element={<SermonSupportPage/>}/>
        <Route path="/worship" element={<PraiseList/>}/>
        <Route path="/worship/detail" element={<PraiseDetail/>}/>
        <Route path="/worship/conti" element={<ContiMaker/>}/>
      </Routes>

      <Footer/>
    </div>
  );
}
